import api from "./api";

export default {
  getAll: () => api.get("/requisicoes_compra"),
  getById: (id) => api.get(`/requisicoes_compra/${id}`),
  update: (id, data) =>
    api.put(`/requisicoes_compra/${id}`, { requisicao_compra: data }),
  destroy: (id) => api.delete(`/requisicoes_compra/${id}`),
  receber: (id, quantidade) =>
    api.patch(`/requisicoes_compra/${id}/receber`, { quantidade }),
};
